// extracted by mini-css-extract-plugin
export var CookieAuth = "index-module--CookieAuth--WSh4p";
export var CookieAuthButton = "index-module--CookieAuthButton--EUYrW";
export var CookieAuthContent = "index-module--CookieAuthContent--UrVYC";
export var CookieAuthShow = "index-module--CookieAuthShow--io6F7";